// Helper de fetch con CSRF para el pack móvil. Sin jQuery, sin @rails/ujs para
// esto: las respuestas se consumen como JSON, no como SJR.
function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

async function request(method, url, body) {
  const headers = { Accept: "application/json", "X-CSRF-Token": csrfToken() }
  if (body !== undefined) headers["Content-Type"] = "application/json"

  let res
  try {
    res = await fetch(url, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined,
      credentials: "same-origin",
    })
  } catch (networkError) {
    // Sin conexión / DNS / timeout de red: nunca llegó respuesta del servidor.
    return { ok: false, status: 0, data: null, networkError: true }
  }

  let data = null
  try {
    data = await res.json()
  } catch (_parseError) {
    // Respuesta sin cuerpo JSON (204, o un error HTML del servidor/proxy).
  }
  return { ok: res.ok, status: res.status, data, networkError: false }
}

export function post(url, body) {
  return request("POST", url, body)
}

export function get(url) {
  return request("GET", url)
}

export function del(url) {
  return request("DELETE", url)
}
